import { Navigate, createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";

import { SkuBrandsPage } from "@/features/inventory";
import { hasAdminRole, useAuth } from "@/shared/auth";

function SkuBrandsRoute(): JSX.Element {
  const { user } = useAuth();
  // Same direct-URL guard as /settings/marketplace-connections.
  if (!hasAdminRole(user)) return <Navigate to="/" />;
  return <SkuBrandsPage />;
}

export const Route = createFileRoute("/_authenticated/settings/sku-brands")({
  component: SkuBrandsRoute,
});
